<div class="pre-auth-content remove-top-padding">
  <div class="container-fluid py-3 py-sm-5">
    <div class="card pre-auth-block">
      <div class="card-body py-4 py-sm-5">
        <h1 class="pb-sm-3">Bank ID Verification</h1>
        <div *ngIf="!tokenIsValid">
          <mat-spinner class="spinner-centre" *ngIf="!errorMsg"></mat-spinner>
          <div *ngIf="errorMsg">
            <p class="text-center">{{errorMsg}}</p>
            <p class="text-center">
              Please try again or <a routerLink="/login">LOG IN</a> with your email and password.
            </p>
            <p class="text-center">
              Please <a routerLink="/register">REGISTER</a> an account if you do not have one.
            </p>
          </div>
        </div>
        <div *ngIf="tokenIsValid">
            <p class="text-center">
              Verification succeeded, logging in...
            </p>
        </div>
      </div>
    </div>
  </div>
</div>

